import { render } from "./product-promoted-campaign.vue?vue&type=template&id=d4947940"
import script from "./product-promoted-campaign.vue?vue&type=script&lang=js"
export * from "./product-promoted-campaign.vue?vue&type=script&lang=js"

import "./product-promoted-campaign.vue?vue&type=style&index=0&id=d4947940&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__